import { render } from "./SmSettings.vue?vue&type=template&id=08155ee8&scoped=true"
import script from "./SmSettings.vue?vue&type=script&lang=js"
export * from "./SmSettings.vue?vue&type=script&lang=js"

import "./SmSettings.vue?vue&type=style&index=0&id=08155ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08155ee8"]])

export default __exports__